// extracted by mini-css-extract-plugin
export var formColumn = "EmbedFormSection-module--formColumn--e2c8c";
export var infoColumn = "EmbedFormSection-module--infoColumn--1a9f4";
export var leftSideMessage = "EmbedFormSection-module--leftSideMessage--a94f8";
export var message = "EmbedFormSection-module--message--1c619";
export var root = "EmbedFormSection-module--root--b8946";
export var segment = "EmbedFormSection-module--segment--db739";